<template>
  <div
    :class="[hasChatNavigation ? 'min-h-[76px] h-[76px]' : 'min-h-[57px] h-[57px]']"
    class="chat-header px-4 py-2">
    <div class="flex items-center">
      <LinkBack
        path="/messages"
        class="pr-3 mr-1 text-gray-900"
        @click="checkFakeInvite"/>

      <div
        v-show="chatUser.name"
        class="flex flex-1">
        <router-link
          :to="premiumSupportAgentUserId.toString() === chatUser.userId ? `${$route.fullPath}` : `/@${chatUser.username}`"
          class="flex"
          @click="clientEventTrack({ typeName: 'chat__header_profile_clicked', userId: chatUser.userId })">
          <Avatar
            class="h-8 w-8 mr-2"
            :show-status="true"
            :user-item="chatUser"/>

          <div class="flex flex-col flex-1">
            <div class="flex items-center gap-1">
              <h3 class="text-sm leading-4 flex gap-1">
                <span class="whitespace-nowrap overflow-hidden text-ellipsis min-w-0 max-w-22">
                  {{ chatUser.name ? chatUser.name.split(' ')[0] : '' }}
                </span>

                <template v-if="(options.verificationEnabled && chatUser.tikTokFollowerCount && !isPremiumSupportUser) || 1">
                  <InlineSvg
                    :src="require('@/assets/svg/design/verified.svg')"
                    class="inline"/>
                </template>
              </h3>

              <RatingsBadge
                v-if="chatUser.rankingPositions"
                :user-id="chatUser.userId"
                :ranking-positions="chatUser.rankingPositions"/>
            </div>

            <div class="flex items-center gap-1.5">
              <AppLastSeenText
                v-if="chatUser.lastSeen?.at"
                :last-seen-at="chatUser.lastSeen.at"/>
              
              <ChatStatus
                v-else-if="features.userStatus?.enabled && isTyping"/>

              <a
                v-else
                class="text-caption text-gray-600 leading-4">@{{ chatUser.username }}</a>

              <!-- <pre>{{ chatUser.lastSeen?.at }}</pre> -->
            </div>
          </div>

          <span
            v-if="chatUser.deleted"
            title="User deleted"
            class="ml-3 flex-shrink-0 rounded-full w-8 h-8 bg-red-400 flex items-center justify-center">
            <InlineSvg
              :src="require('@/assets/svg/regular/trash.svg')"
              class="w-3.5 h-3.5 text-white mb-0.5"/>
          </span>
        </router-link>
      </div>

      <AppBalance v-if="options.chatCreditBalanceEnabled && !isPremiumSupportUser"/>

      <AppReportDots
        v-if="isAuthenticated && !isPremiumSupportUser"
        :update-user="userGet"
        :source="'chat_header'"
        :user="chatUser"/>
    </div>

    <ChatNavigation
      v-if="hasChatNavigation"/>

    <Modal
      v-slot="{ values, closeModal }"
      ref="blockModal"
      name="BlockUser">
      <BlockUserContent
        :heading="$t('creator.block.block_user')"
        :values="values"
        @close="closeModal()"/>
    </Modal>

    <Modal
      v-slot="{ values, closeModal }"
      ref="reportModal"
      name="ReportUser">
      <BlockUserContent
        :heading="$t('creator.block.report_user')"
        :values="values"
        type="report"
        @close="closeModal()"/>
    </Modal>

    <Modal
      v-slot="{ closeModal }"
      ref="notEnoughCreditsModal"
      name="NoCredits"
      position="bottom"
      overflow-class="overflow-y-auto"
      content-class="bg-white p-5"
      wrapper-class=""
      rounded-class="rounded-t-2.5xl"
      :show-close-cross="false"
      :has-indents="false">
      <NoCreditsContent @close="closeModal()"/>
    </Modal>
  </div>
</template>

<script>
import Avatar from '@/components/Functional/Avatar.vue'
import LinkBack from '@/components/Functional/LinkBack.vue'
import Modal from '@/components/Functional/Modal.vue'
import BlockUserContent from '@/components/ModalContents/BlockUserContent.vue'
import { mapActions, mapState, mapWritableState } from 'pinia'
import { useChatStore } from '@/stores/chat'
import { useAuthStore } from '@/stores/auth'
import { useUserStore } from '@/stores/user'
import helpers from '@/helpers'
import { useDialogsStore } from '@/stores/dialogs'
import NoCreditsContent from '@/components/ModalContents/chat/NoCreditsContent.vue'
import { clientEventTrack } from '@/helpers/methods'
import ChatNavigation from '@/components/Chat/ChatMessages/ChatNavigation.vue'
import ChatStatus from '@/components/Chat/ChatStatus.vue'
import AppBalance from '@/components/App/AppBalance.vue'
import RatingsBadge from '@/components/Ranking/Common/RankingBadge.vue'
import AppReportDots from '@/components/App/AppReportDots.vue'
import AppLastSeenText from '@/components/App/AppLastSeenText.vue'

export default {
  name: 'ChatHeader',
  components: {
    LinkBack,
    Avatar,
    Modal,
    BlockUserContent,
    NoCreditsContent,
    ChatNavigation,
    ChatStatus,
    AppBalance,
    RatingsBadge,
    AppReportDots,
    AppLastSeenText
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(useUserStore, [
      'premiumSupportAgentUserId',
      'balance',
      'features'
    ]),
    ...mapState(useAuthStore, [
      'isAuthenticated',
      'options'
    ]),
    ...mapState(useChatStore, [
      'chatUser',
      'sortedMessages',
      'partnerChatStatus'
    ]),
    isTyping () {
      return this.partnerChatStatus?.status === 'typing'
    },
    ...mapWritableState(useDialogsStore, [
      'fakeInvite'
    ]),
    ...mapState(useUserStore, [
      'premiumSupportAgentUserId'
    ]),
    isPremiumSupportUser () {
      return this.premiumSupportAgentUserId.toString() === this.chatUser.userId
    },
    hasChatNavigation () {
      return this.chatUser && !this.isPremiumSupportUser && this.options.chatNavigationEnabled
    }
  },
  mounted () {
    this.checkFakeInvite()
  },
  methods: {
    ...mapActions(useChatStore, [
      'userGet'
    ]),
    clientEventTrack: clientEventTrack,
    showSignUp () {
      helpers.openSignInByEmailModal()
    },
    checkFakeInvite () {
      if ((this.fakeInvite?.userId === this.chatUser.userId) && this.sortedMessages.length > 0) {
        this.fakeInvite.contact = true
      }
    }
  }
}
</script>

<style>
  .chat-header {
    @apply flex-grow-0 border-l border-r border-gray-100 w-full
  }
</style>
